<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useFetchDtwinModels } from "~/modules/dtwin/composables/useFetchDtwinModels";
import { getDtwinTypeLabel } from "~/modules/dtwin/utils/getDtwinTypeLabel";
import { getLifeCycleStateProperties } from "~/modules/dtwin/utils/getLifeCycleStateProperties";
import { useOrganizationStore } from "~/modules/organization/stores/useOrganizationStore";
import type { Sector } from "~/modules/sector/models/Sector.interface";
import { SectorResource } from "~/types";

const { t, te } = useI18n();

const { currentOrganization } = storeToRefs(useOrganizationStore());

const { results: resultsAllDtwinModels, fetchAll: fetchAllDtwinModels } =
  useFetchDtwinModels({
    organizationCode: currentOrganization.value?.code,
  });

defineProps<{
  sector: Sector;
}>();
const emits = defineEmits(["change"]);

function onChange() {
  emits("change");
}

onMounted(fetchAllDtwinModels);
</script>
<template>
  <sector-toolbar
    ref="sectorToolbar"
    primary-key="uid"
    :sector="sector"
    :resource="SectorResource.DTWINS"
    @change="onChange"
  >
    <lxc-table-column
      prop="attributes.friendlyName"
      :label="t('dtwins.list.attributes.friendlyName')"
    />
    <lxc-table-column
      prop="attributes.type"
      :label="t('dtwins.list.attributes.type')"
      width="12rem"
    >
      <template v-if="resultsAllDtwinModels" #default="scope">
        {{ getDtwinTypeLabel(resultsAllDtwinModels, scope.row) }}
      </template>
    </lxc-table-column>
    <lxc-table-column :label="t('dtwins.list.attributes.state')" width="12rem">
      <template #default="scope">
        {{ getLifeCycleStateProperties(scope.row.lifeCycleState, t, te).label }}
      </template>
    </lxc-table-column>
  </sector-toolbar>
</template>
